import Vue from 'vue';
import fetch from '../../../services/fetch';

const state = {
  insurances: {
    status: null,
    calculations: {
      goal: {}
    },
    ins: {},
    pensions: {},
  }
};

const getters = {
  insurances: (state) => state.insurances,
};

const actions = {
  async getInsurances ({ commit, dispatch }) {
    commit('setInsuranceStatus', 'loading')

    const insurances = await fetch.get('/insurance').then(res=>res.data)

    commit('setInsurances', {
      status: 'loaded',
      calculations: insurances.calculations,
      ins: insurances.insurances,
      pensions: insurances.pensions,
    })
  },
  async updateGoal ({ commit, state }, data) {
    return fetch.post('/goal', {
        goal: {
          monthlyPayment: data.monthlyPayment,
          pensionAge: data.pensionAge,
          riskClass: data.riskClass,
          savings: data.savings,
        }
    }).then(response => {
      commit('setCalculations', response.data.calculations)
    })
  },
};

const mutations = {
  setInsuranceStatus: (state,status) => Vue.set(state.insurances, 'status', status),
  setInsurances: (state,insurances) => Vue.set(state, 'insurances', insurances),
  setCalculations: (state, data) => Vue.set(state.insurances, 'calculations', data),
};

export default {
  state,
  getters,
  actions,
  mutations
}